export default {"src":"/_next/static/media/logoTaskgripLight.2337321c.svg","height":292,"width":1261,"blurWidth":0,"blurHeight":0};